import { EncodeSpecificationType } from "../../admin/encode-specification/context/EncodeSpecificationItem";
import { MuxSpecificationLookupResponse } from "../api/orders-api/mux-specification/responses/GetMuxSpecificationsLookupResponse";
import { MuxerType } from "./MuxerType";

export type MuxSpecification = {
    id: string;
    name: string;
    muxerType: MuxerType;
    encodeSpecificationType: EncodeSpecificationType;
};

export const mapToMuxSpecification = (response: MuxSpecificationLookupResponse): MuxSpecification => ({
    id: response.id,
    name: response.name,
    muxerType: response.muxerType,
    encodeSpecificationType: response.encodeSpecificationType
});
